import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const excluirCaracteristicaService = async (id: number) => {
  const Token = validateToken();

  if (!Token) return false;

  try {
    const response = await axios.delete(
      `${Globais.DOMINIOBACK}/caracteristicas/${id}`,
      {
        headers: { Authorization: Token.AuthStr },
      }
    );

    return response?.data || true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
